import { render } from "./BuscarTicketView.vue?vue&type=template&id=08aff48e"
import script from "./BuscarTicketView.vue?vue&type=script&lang=js"
export * from "./BuscarTicketView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__